// Card #2572: the competitor portal's show dates arrive from the API as plain
// calendar-day strings ("2026-07-17"). Render them as US MM/DD/YYYY.
//
// Pure string arithmetic on purpose: a show date is a calendar day, not an
// instant, so it must never round-trip through `new Date("2026-07-17")` (which
// parses as UTC midnight and renders a day early in every US timezone).
// Anything that is not a strict YYYY-MM-DD is returned unchanged rather than
// guessed at.
const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function formatShowDate(value) {
  const s = String(value ?? "").trim();
  const m = ISO_DAY.exec(s);
  if (!m) return s;
  return `${m[2]}/${m[3]}/${m[1]}`;
}

// Card #1957 (bug 181) — show labels carry the DATE so a rider can tell two
// shows apart at a glance, including two shows with near-identical names on
// the same or adjacent days (the real Bello Acres Summer Dressage 1 / 2
// case). Dates arrive as plain YYYY-MM-DD strings and render in US
// MM/DD/YYYY (card #2572); a single-day show shows one date, a multi-day
// show shows its range.
export function dateLabel(show) {
  if (!show?.startDate) return "";
  const start = formatShowDate(show.startDate);
  if (!show.endDate || show.endDate === show.startDate) return start;
  return `${start} – ${formatShowDate(show.endDate)}`;
}

export function showOptionLabel(show) {
  if (!show) return "";
  const date = dateLabel(show);
  return date ? `${show.name} (${date})` : show.name;
}
